import { keepPreviousData, useQuery } from "@tanstack/vue-query";
import { type MaybeRefOrGetter, toValue } from "vue";

import { pb, pbCollectionNames } from "#api/pocketbase";
import type { Content } from "./content.types";

// NOTE: Query keys used for invalidation should require all arguments, as 'undefined' in query key
//         prevents invalidating any queries with similar key but that do provide args for that argument!
export const contentKeys = {
  all: ["content"],
  byCode: (code: MaybeRefOrGetter<string>) => [...contentKeys.all, code],
} as const;

export const getContentByCode = (code: string) => {
  return pb.collection(pbCollectionNames.content).getFirstListItem<Content>(`code = '${code}'`);
};

export const useContentQuery = (code: MaybeRefOrGetter<string>) => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: contentKeys.byCode(code),
    queryFn: async () => {
      return getContentByCode(toValue(code));
    },
  });
};
